import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import Topic from "@/pages/topic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "/topics/:slug",
    element: <Topic />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;